module.exports = __webpack_public_path__ + "img/zzf.78493388.jpg";